import { copyRight } from "../Copy";


export const PageWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="h-screen flex flex-col min-w-0 min-h-0">
            {children}
        </div>
    );
}

type MainContentWrapperProps = {
    sideMenuIsOpen: boolean
    isMobile: boolean
    isFullScreen?: boolean
    children: React.ReactNode
}
export const MainContentWrapper = ({ sideMenuIsOpen, isMobile, isFullScreen, children }: MainContentWrapperProps) => {
    return (
        <main
            className={`min-h-0 flex-1 flex flex-col overflow-y-auto [scrollbar-gutter:stable]
        ${sideMenuIsOpen ? "md:pl-[286px]" : "md:pl-[90px]"}`}
            style={{
                paddingTop: isMobile
                    ? "calc(var(--notif-height, 0px) + 0.5rem)"
                    : "calc(var(--notif-height, 0px) + 1rem)",
            }}
        >
            <div
                className={
                    isFullScreen
                        ? "flex-1 mx-auto w-full max-w-none px-4 py-4"
                        : `flex-1 mx-auto w-full max-w-[1200px] px-6 ${isMobile ? "py-2" : "py-6"}`
                }
            >
                {children}
            </div>

            {/* Footer at the bottom */}
            <div className="shrink-0 px-6 py-4 md:-ml-8">
                {copyRight}
            </div>
        </main>
    )
}
